import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../../../../../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { ScoringType } from "../../../../../misc/tools";
import { GameBaseScenario } from "../../../../GameBaseScenario";
import { scenario3IncorrectPtAdmittedAudioCaching, scenario3IncorrectPtAdmittedVideoSegments } from "../../../scenario3-incorrect-pt-admitted";
import { IncorrectPtAdmittedComponentsStep0ComponentMainConfig, IncorrectPtAdmittedComponentsStep0ComponentPart1Config } from "../incorrect-pt-admitted-components-step0";

export default class IncorrectPtAdmittedComponentsStep0Part1 extends BaseScenarioPart<GameBaseScenario> {
	private get config(): IncorrectPtAdmittedComponentsStep0ComponentPart1Config {
		return this.mainConfig.part1Config;
	}
	constructor(scenario: GameBaseScenario, private onDone: () => void, private id: string, private mainConfig: IncorrectPtAdmittedComponentsStep0ComponentMainConfig) {
		super(scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	private stepName = 'Step 1';

	public start() {
		this.section1();
	}

	public section1() {
		const context = this;
		let chapter = context.config.chapter;
		context.playVideoChapter(chapter(), () => {
			context.section2();
		})
	}

	public section2() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType1UI({
			title: this.mainConfig.scenario.props.name,
			subtitle: (this.stepName + ' - Question 1'),
			audioUrl: scenario3IncorrectPtAdmittedAudioCaching.getItemByKey(scenario3IncorrectPtAdmittedAudioCaching.audioKeys.question1).src,
			questionTitle: 'Select the one that best describes the employee\'s action ',
			options: [
				{
					title: 'Human Error',
					description: `
						<ul>
						<li>The employee is not accountable.</li>
						<li>The employee should be consoled.</li>
						<li>The employee should be interviewed and consulted during any systems level analysis.</li>
						</ul>
					`,
					feedbackHtml: `
						<p class="default-text">Rose did not commit an error while working appropriately 
						and in the patient’s best interest.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'At Risk Behavior',
					description: `
						<ul>
						<li>The employee is accountable and should receive coaching.</li>
						<li>The employee may participate in teaching others the lessons learned.</li>
						</ul>
					`,
					feedbackHtml: `
						<p class="default-text">Correct. Rose made a risky choice that was faulty. 
						It may even be considered a routine rule violation.</p>
					`,
					isCorrect: true,
					score: ScoringType.good
				},
				{
					title: 'Reckless Behavior',
					description: `
						<ul>
						<li>Discipline may be warranted.</li>
						<li>The employee is accountable and should receive re-training/coaching as necessary.</li>
						<li>The employee may participate in teaching others the lessons learned.</li>
						</ul>
					`,
					feedbackHtml: `
						<p class="default-text">This is not the best option. Rose’s behavior is risky. 
						She did not knowingly violate a rule or made a risky choice.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				}
			],
			
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario3IncorrectPtAdmittedVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType1(selectedChoices[0], (this.stepName + ' - Question 1 '), parentQuestionConfig, () => {
					this.section3();
				}, () => {
					this.section3();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[0], mentorInfo.chapterIds[1], mentorInfo.chapterIds[2], 'Human Error');
			}
		}, 0);
	}

	public section3() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType1UI({
			audioUrl: scenario3IncorrectPtAdmittedAudioCaching.getItemByKey(scenario3IncorrectPtAdmittedAudioCaching.audioKeys.question2).src,
			title: this.mainConfig.scenario.props.name,
			subtitle: (this.stepName + ' - Question 2'),
			questionTitle: 'Based on the correct answer, what is the appropriate path to take with the employee ',
			options: [
				{
					title: 'Console',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">This is not the best option. Rose did not make a 
						mistake while working appropriately and in the patient’s best interest.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'Console and coach',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">Correct. The recommended path is to console the employee, 
						then coach them back to a safe place. It is important to help the employee see the 
						risk involved in making the choices they did - so they can modify 
						their behavior in the future.</p>
					`,
					isCorrect: true,
					score: ScoringType.good
				},
				{
					title: 'Console, coach, and consider discipline',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">This is not the best option. Consider disciplinary action 
						as the employee actions are considered reckless and a repeated behavior.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				}
			],
			
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario3IncorrectPtAdmittedVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType1(selectedChoices[0], (this.stepName + ' - Question 2 '), parentQuestionConfig, () => {
					this.onDone();
				}, () => {
					this.onDone();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[3], mentorInfo.chapterIds[4], mentorInfo.chapterIds[5], 'Console');
			}
		}, 1);
	}
}